import React from "react";
import "./Career.css";
import OpenPositions from "./OpenPositions";

const values = [
  {
    title: "Reliability",
    description: "We are committed to building a platform people can trust every single day."
  },
  {
    title: "Simplicity",
    description: "We believe logistics should be easy, transparent, and efficient for everyone."
  },
  {
    title: "Innovation",
    description: "We use technology to rethink traditional transport and create better solutions."
  },
  {
    title: "Ownership",
    description: "We take responsibility for our work and always strive to deliver the best results."
  },
  {
    title: "Customer First",
    description: "Every decision starts with improving the experience for our users and partners."
  }
];

export default function Career() {
  return (
    <div>
      {/* PAGE HERO */}
      <div className="page-hero">
        <span className="page-hero-label">Careers</span>
        <h1>Build the Future of Logistics</h1>
        <p>
          At Mr Truck, we are building real-world solutions that help businesses move goods faster
          and help transporters earn more. Ideas matter here — every team member makes a meaningful impact.
        </p>
      </div>

      {/* CULTURE */}
      <div className="page-section bg-off-white">
        <span className="section-label">Culture</span>
        <h2>Our Culture</h2>
        <p className="page-section-subtitle">
          We move fast, solve real logistics challenges, and work together to make transport more efficient.
        </p>
        <div className="culture-text">
          <p>
            Our culture is built on speed, collaboration, and ownership. Every team member is trusted to
            take initiative, contribute ideas, and help drive Mr Truck forward.
          </p>
          <p>
            Great work happens when talented people are empowered to build and improve. If you care
            about real impact, you will thrive here.
          </p>
        </div>
      </div>

      {/* VALUES */}
      <div className="page-section">
        <span className="section-label">What We Stand For</span>
        <h2>Our Values</h2>
        <p className="page-section-subtitle">
          The principles that guide every decision we make as a team.
        </p>
        <div className="values-grid">
          {values.map((value, index) => (
            <div className="value-card" key={index}>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* OPEN POSITIONS */}
      <OpenPositions />

      {/* FINAL CTA */}
      <div className="page-cta bg-navy">
        <h2 style={{ color: "white" }}>Ready to Make an Impact?</h2>
        <p style={{ color: "rgba(255,255,255,0.78)" }}>
          Join Mr Truck and help transform the way goods move across Africa.
        </p>
        <button
          className="careers-cta-btn"
          onClick={() => window.location.href = "mailto:careers@mrtruck.co.ke"}
        >
          Apply Now — careers@mrtruck.co.ke
        </button>
      </div>
    </div>
  );
}
